import { render } from "./Afiliado.vue?vue&type=template&id=6b9e5068"
import script from "./Afiliado.vue?vue&type=script&lang=js"
export * from "./Afiliado.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__